import React, { useEffect, useRef, useState } from 'react';
import './AddImages.scss';
import firebase from '../../../FirebaseConfig/firebase';
import { AiFillPlusCircle, AiFillDelete } from 'react-icons/ai';
import { updateGlobal, uploadFile } from '../../../services/DashboardService';
import { useStateValue } from '../../../services/ContextProvider';
import { globalActionTypes } from '../../../services/Reducers/GlobalReducer';
import { FaImages } from 'react-icons/fa';
import { RiUploadCloudFill } from 'react-icons/ri';
import { MdAddCircle } from 'react-icons/md';

const AddImages = () => {
    const db = firebase.firestore();
    const inputFileRf = useRef(null);
    const [fileUrl, setFileUrl] = useState('');
    const [fileToBeUploaded, setFileToBeUploaded] = useState(null);
    const [imageCount, setImageCount] = useState(false);
    const [progress, setProgress] = useState(0);
    const { globalState, globalDispatch } = useStateValue();
    const [carouselArr, setCarouselArr] = useState(globalState.globalCarousel || []);


    useEffect(() => setCarouselArr(globalState.globalCarousel), [globalState.globalCarousel, imageCount]);
    useEffect(() => {
        if (carouselArr.length >= 5) {
            setImageCount(true);
        } else {
            setImageCount(false);
        }
    }, [carouselArr]);
    //useEffect(() => {
    //    db.collection('carouselimages').get().then((snapshot) => {
    //        const photo = snapshot.docs.map((doc => {
    //            return {
    //                id: doc.id,
    //                ...doc.data()
    //            };
    //        }));
    //        if (photo.length >= 5) {
    //            setImageCount(true);
    //        }

    //        if (photo.length < 5) {
    //            setImageCount(false);
    //        }
    //        setSliderImages(photo);
    //    });
    //}, [checkImage]);


    const addImage = async (e) => {

        //getting a unique name for the file
        if (fileToBeUploaded) {
            const fileName = Date.now().toString();

            //create an uploading space
            const uploadTask = uploadFile('carousel/' + fileName, fileToBeUploaded);

            //listen on upload process
            uploadTask.on('stage_changed', (snapshot) => {
                setProgress((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
            }, (err) => {
                console.log(err);
            }, async () => {
                try {
                    //get the public URL if completed
                    const publicUrl = await uploadTask.snapshot.ref.getDownloadURL();

                    //update the global data document
                    updateGlobal({
                        carousel: [...carouselArr, {
                            publicUrl,
                            fileName,
                            totalBytes: uploadTask.snapshot.totalBytes
                        }]
                    });

                    globalDispatch({
                        type: globleActionTypes.SET_GLOBAL_CAROUSEL,
                        globalCarousel: [...carouselArr, {
                            publicUrl,
                            fileName,
                            totalBytes: uploadTask.snapshot.totalBytes
                        }]
                    });

                    setTimeout(() => setProgress(0), 100);

                } catch (e) {
                    console.log(e);
                }
            });
        }
    };

    const deleteImage = async (fileName) => {
        console.log(fileName);
        try {
            // update the global data document
            await updateGlobal({
                carousel: carouselArr.filter(e => e.fileName !== fileName)
            });

            // remove file from storage bucket
            //await deleteFil('carousel/' + fileName);

            // Create a reference to the file to delete
            var storage = firebase.storage();
            var storageRef = storage.ref();
            var desertRef = storageRef.child('carousel/' + fileName);

            // Delete the file
            desertRef.delete().then(() => {
                console.log('deleted');
            }).catch((error) => {
                // Uh-oh, an error occurred!
            });



            if (carouselArr.length >= 5) {
                setImageCount(false);
            } else {
                setImageCount(true);
            }
        } catch (err) {
            console.log(err);
        }

    };

    return (
        <div className="add-images-container">
            


            <div >
            <div class="m-4" >
                <h4 class="display-4 addproject-carosel-img">< FaImages/>&nbsp;&nbsp;<b>Upload Carousel Images</b> </h4>
            </div>
            <hr />

                {
                    !imageCount &&
                    <div>

                        <input  id="imageUpload" ref={inputFileRf} style={{ display: 'none' }} type='file' accept='image/*' onChange={(e) => setFileToBeUploaded(e.target.files[0])} />
                      
                        <MdAddCircle class="custom-file-input add-img-btn mx-2"  onClick={() => inputFileRf.current.click()}/>
                        {fileToBeUploaded && (
                                <span>
                                    {
                                     '(' + fileToBeUploaded.name + ')'
                                    }
                                </span>
                            )}
                        
                        
                        {/* <button  onClick={() => inputFileRf.current.click()}>
                            Select Image {fileToBeUploaded && (
                                <span>
                                    {
                                        '(' + fileToBeUploaded.name + ')'
                                    }
                                </span>
                            )}
                        </button> */}
                        
                        <button type="button" class="btn btn-primary btn-sm mb-1 mx-2" onClick={addImage}>
                           <RiUploadCloudFill/>&nbsp; Upload Image
                        </button>

                    </div>
                }

                {
                    imageCount &&
                        <div class="col-md-11 alert alert-warning text-center" role="alert">
                        Reached a <b>maximum number</b>  of carousel images, Please remove existing to upload new photos!!!</div>
                   
                }
            </div>

            <div className="d-flex flex-wrap">
            
                {
                    carouselArr.map((image, index) => {
                        return (
                            <div key={index} className=" added-slider-images-container2">
                                
                                <div className="card  p-2 m-2 mb-0">
                                    <div className="pb-2">
                                        <img src={image.publicUrl} alt="k" className="added-slider-image img-fluid" /> <br />
                                            
                                        {/* <AiFillDelete className="slider-image-deleteicon" onClick={() => deleteImage(image.fileName)} /> */}
                                    </div>
                                    <a  class="btn btn-danger " onClick={() => deleteImage(image.fileName)}>Delete</a>
                                </div>

                            </div>
                        );
                    })
                }
                
            </div>
        </div>
    );
};

export default AddImages;
